<template>
  <div class="bg-charcoal-100 min-h-dvh flex flex-col">
    <div class="grow text-center px-8 flex items-center justify-center py-20">
      <div>
        <img :src="gifs[randomBetween(0, gifs.length - 1)]" class="block mx-auto rounded-lg" style="height: 200px">

        <p class="font-bold text-2xl md:text-4xl mt-6 mb-2">
          {{ $t('pages.error.title', { code: error?.statusCode}) }}
        </p>

        <p class="text-charcoal-500" v-if="error?.statusMessage">
          {{ $t('pages.error.content', { message: error.statusMessage ?? '' }) }}
        </p>

        <div class="mt-6">
          <ButtonBase class="text-underline" @click.native="handleError">
            {{ $t('pages.error.action') }}
          </ButtonBase>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { NuxtError } from '#app'
import UserStore from '@/store/user'
import { randomBetween } from '@/utils/useRandom'

const props = defineProps({
  error: Object as () => NuxtError
})

const userStore = UserStore()
const { currentUser } = storeToRefs(userStore)

console.error(props.error?.message)

const gifs = ref([
  'https://media.tenor.com/8aVSI_3m_oAAAAAd/run-running.gif',
  'https://media.tenor.com/g5OJCnQBYPYAAAAd/running-away-mascot.gif',
  'https://media.tenor.com/7E4TF1H_kUQAAAAd/funny-animals-lol.gif',
  'https://media.tenor.com/L5MmuLQwvx8AAAAd/mascot-angry.gif',
  'https://media.tenor.com/B0aKshN0QpcAAAAd/gta-gtav.gif',
  'https://media.tenor.com/yZxBto83TkEAAAAd/monkey-ape.gif',
  'https://media.tenor.com/sPn8-fZm8TsAAAAC/rekt-monkey.gif',
  'https://media.tenor.com/cJRcMyUAiMcAAAAd/ah-shit-here-we-go-again-ah-shit.gif',
  'https://media.tenor.com/Fw-IvchvMCIAAAAd/fifa-funny-marcelo.gif',
  'https://media.tenor.com/7Fm4sFKF5_AAAAAC/confusedslow.gif',
  'https://media.tenor.com/2wEmgwPNLbEAAAAd/pikachu-dance.gif',
  'https://media.tenor.com/5nja624JIQAAAAAd/puppy-dog.gif',
  'https://media.tenor.com/EaSc8OnFn28AAAAd/lizard-salamander.gif',
  'https://media.tenor.com/i4JaoRU9VlYAAAAd/elias-turtle-elias.gif',
  'https://media.tenor.com/YnEP3yGW6RcAAAAd/asmrthechew-stare.gif',
  'https://media.tenor.com/XAw7t5WFRrEAAAAC/caroline-cameron-sportsnet.gif',
  'https://media.tenor.com/9p1szx-4Q3YAAAAM/fringe-fail.gif',
  'https://media.tenor.com/VvnRXVC5op4AAAAd/nebuer-styles-drag.gif',
  'https://media.tenor.com/Wo_QM_y6c_EAAAAM/girl-wii.gif',
  'https://media.tenor.com/-WCbK43rv2MAAAAM/kotique-cat-tongue.gif',
  'https://media.tenor.com/P9n8oq7YN2wAAAAC/kl-koh.gif',
  'https://media.tenor.com/obawzLL_0BsAAAAd/trabajando-haciendo.gif',
  'https://media.tenor.com/wQFMWJyaD98AAAAd/otter-fright.gif',
  'https://media.tenor.com/24rrwgIBB-0AAAAd/dog-side-eye.gif',
  'https://media.tenor.com/qnfTWMLDFXsAAAAd/white-gay-gay.gif',
  'https://media.tenor.com/p2Bq1ZmegDgAAAAC/gays-gays-fighting.gif',
  'https://media.tenor.com/OgOuNn3KVIsAAAAC/the-office-walk-away.gif',
  'https://media.tenor.com/7r-BGEoIohkAAAAd/meme-cat.gif',
  'https://media.tenor.com/Zg4IASBSaUEAAAAd/cat.gif',
  'https://media1.tenor.com/images/3f78c664bfbc22e1f9f2a3479ff563e8/tenor.gif?itemid=22101924',
  'https://media1.tenor.com/images/b890befe043ae013a3fb5209e7168082/tenor.gif?itemid=26368900',
])

const handleError = () => {
  reloadNuxtApp({ path: '/' })
}

definePageMeta({
  layout: 'app'
})
</script>